import { useCallback } from 'react';
import useAxiosInstance from './axiosInstance';

/**
 * Custom hook to analyze all files from the server.
 * @param {function} navigate - Function to navigate to another page.
 * @returns {object} Object containing the analysisAllFiles function.
 */
const useFileAnalysis = (navigate, container_name=null) => {
  const axiosInstance = useAxiosInstance(navigate);

  const analysisAllFiles = useCallback(async () => {
    try {
      const response = await axiosInstance.get(container_name ? `/tax_reference_all?container=${container_name}` : '/tax_reference_all');
      return response.data;
    } catch (error) {
      console.error('Error analyzing files:', error);
      throw error;
    }
  }, [axiosInstance, container_name]);

  return { analysisAllFiles };
};

export default useFileAnalysis;
